import LoginButton from './LoginButton';

const Activation = () => {
  return (
    <div className="stockwiz-landing__container__activation border-gradient">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <div className="d-none d-md-flex align-items-start gap-5">
          <img src="/b2b/stockwiz/svg/lock.svg" alt="lock" />
          <div>
            <h2 className="fw-semibold fs-4">
              Login to <span className="text-gradient">StrykeX</span> Algos
            </h2>
            <p className="text-white-50 small">Click on the below mentioned buttons to activate your plan</p>
          </div>
        </div>

        <div className="d-flex d-md-none flex-column gap-2">
          <div className="d-flex align-items-center gap-2">
            <img src="/b2b/stockwiz/svg/lock.svg" alt="lock" />
            <h2 className="fs-5 fw-medium">
              Login to <span className="text-gradient">StrykeX</span> Algos
            </h2>
          </div>
          <p className="text-white-50 small">Click on the below mentioned buttons to activate your plan</p>
        </div>

        <div className="d-none d-md-flex flex-column gap-2">
          <div className="d-flex align-items-center gap-2 justify-content-end">
            <img
              src="/b2b/stockwiz/svg/football.svg"
              alt="help"
              className="stockwiz-landing__container__activation__world-img"
            />
            <a
              className="stockwiz-landing__container__activation__need-help"
              href="https://api.whatsapp.com/send?phone=916350670245&text=I%20need%20assistance%20with%20StrykeX%2C%20please%20connect%20me%20to%20the%20support%20team"
              target="_blank"
              rel="noopener noreferrer"
            >
              Need Help?
            </a>
          </div>
          <p>Click here to connect with our support team</p>
        </div>
      </div>

      <LoginButton />

      <div className="d-block d-md-none mt-3">
        <div className="d-flex align-items-center gap-2">
          <img
            src="/b2b/stockwiz/svg/football.svg"
            alt="help"
            className="h-100"
            style={{ height: '20px', width: '20px' }}
          />
          <span className="fw-medium text-white text-decoration-underline">Need Help?</span>
        </div>
        <span className="text-white-50 small">Click here to connect with our support team</span>
      </div>
    </div>
  );
};

export default Activation;
